import join from 'url-join';

import { PageURL } from '@app/core/widgets/pages';

const MAKE_TRANSFER = join(PageURL.TRANSFERS_PAYMENTS, '/make-transfer');
const PLAID = join(PageURL.BANK_ACCOUNT, '/plaid');
const EXTERNAL_TRANSFER = join(MAKE_TRANSFER, 'external');
const DISPUTE_TRANSACTION = join(PageURL.MESSAGE_CENTER, 'dispute-transaction');

export const COMMON_PAGES = {
  MAKE_TRANSFER,
  PLAID,
  EXTERNAL_TRANSFER,
  DISPUTE_TRANSACTION,
};
